import {gql} from '@apollo/client';

/**
 * 서브카테고리별 실측 가이드 이미지 + 전체 측정 항목을 조회합니다.
 */
export const GET_SUBCATEGORY_MEASUREMENT_ITEMS = gql`
    query getSubcategoryMeasurementItems($subcategoryName: String!) {
        getSubcategoryMeasurementItems(subcategoryName: $subcategoryName) {
            subcategory {
                id
                guide_image
            }
            measurement_item {
                id
                key
                label
                unit
                description
            }
        }
    }
`;
